module.exports = __webpack_public_path__ + "img/3豪华双层套房 1.31ca983.jpg";